import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import logo from '../assets/logo.png';
import { useUser } from '../context/userContext';
import ChangeLanguage from '../components/ChangeLanguage';
import IOSDownload from '../components/IOSDownload';
import { isIos, isInStandaloneMode } from '../utils/helpers';

const LoginPage: React.FC = () => {
  const [isNewPassword, setIsNewPassword] = useState(false);
  const { t } = useTranslation();
  const { login } = useUser();
  const [deferredPrompt, setDeferredPrompt] = useState<Event | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [credentials, setCredentials] = useState({
    username: '',
    password: '',
  });

  useEffect(() => {
    const handler = (e: Event) => {
      e.preventDefault();
      setDeferredPrompt(e);
    };
    window.addEventListener('beforeinstallprompt', handler);
    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  const handleInstallClick = (): void => {
    if (deferredPrompt) {
      (deferredPrompt as any).prompt();
      (deferredPrompt as any).userChoice.then((choiceResult: any) => {
        setDeferredPrompt(null);
      });
    }
  };

  const handleLogin = async (e: React.FormEvent): Promise<void> => {
    e.preventDefault();
    try {
      await login(credentials.username, credentials.password);
      console.log('Login successful');
    } catch (error) {
      console.error('Login failed', error);
      if (error instanceof Error) {
        setError(error.message);
      }
    }
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    const { name, value } = e.target;
    setCredentials((prev) => ({ ...prev, [name]: value }));
  };

  return (
    <div className="loginPage">
      <img className="logo" src={logo} alt="Logo" />
      {isIos() && !isInStandaloneMode() ? (
        <IOSDownload />
      ) : (
        deferredPrompt && (
          <button className="button" onClick={handleInstallClick}>
            {t('btnInstall')}
          </button>
        )
      )}
      <div className="loginBox">
        <h2>{isNewPassword ? t('newPassword') : t('login')}</h2>
        {isNewPassword ? (
          <>
            <form>
              <input
                type="password"
                placeholder={t('password')}
                name="password"
                onChange={handleInputChange}
              />
              <button type="submit">{t('newPasswordButton')}</button>
            </form>
            <p className="link" onClick={() => setIsNewPassword(false)}>
              {t('back')}
            </p>
          </>
        ) : (
          <>
            <form onSubmit={handleLogin}>
              <input
                type="text"
                placeholder={t('username')}
                name="username"
                onChange={handleInputChange}
              />
              <input
                type="password"
                placeholder={t('password')}
                name="password"
                onChange={handleInputChange}
                />
                {error && <p className="error">{t(error)}</p>}
              <button type="submit">{t('loginButton')}</button>
            </form>
            <p className="link" onClick={() => setIsNewPassword(true)}>
              {/* {t('newPassword')} */}
            </p>
          </>
        )}
        <ChangeLanguage />
      </div>
    </div>
  );
};

export default LoginPage;
